module.exports = __webpack_public_path__ + "img/eyebank-logo.3374bf46.png";